<!--
 * @Author: your name
 * @Date: 2020-08-02 22:15:06
 * @LastEditTime: 2020-08-08 12:35:23
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: /xdap-h5/src/lib/ui/components/x-user-tag/x-user-tag.vue
-->
<template>
  <div class="x-user-tag">
    <x-person-avatar
      :avatarUrl="avatarUrl"
      :personName="personName"
    ></x-person-avatar>
    <span>{{ personName }}</span>
  </div>
</template>

<script>
export default {
  name: 'XUserTag',
  props: {
    avatarUrl: {
      type: String,
      default: ''
    },
    personName: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss">
.x-user-tag {
  height: 1.72rem;
  line-height: 1.72rem;
  border-radius: 0.86rem;
  background-color: #F7F7F7;
  display: inline-flex;
  align-items: center;
  white-space: nowrap;
  > span {
    padding-left: .285rem;
    padding-right: .86rem;
    font-size: 1rem;
  }
}
</style>